import client from '@/config/directus.api';
import { find, findIndex, filter, get } from 'lodash';
import * as TemplatesService from '@/services/template';
import * as TemplateCategories from '@/services/w2p_templatecategories';

export default {
  namespaced: true,

  state: {
    categories: [],
    category_details: [],
    designs: [],
    templates: []
  },

  getters: {
    CATEGORIES: state => state.categories,

    CATEGORIES_CAMPAIGNS: state => {
      let result = [];

      if (state.categories.length) {
        result = state.categories.filter(category => {
          const nav_groups = get(category, 'nav_groups');
          return nav_groups.includes('campaigns');
        });
      }

      return result;
    },

    CATEGORIES_MEDIA: state => {
      let result = [];

      if (state.categories.length) {
        result = state.categories.filter(category => {
          const nav_groups = get(category, 'nav_groups');
          return nav_groups.includes('mediathek');
        });
      }

      return result;
    },

    GET_CATEGORY_BY_ID: state => id => {
      return find(state.categories, { id: id });
    },

    GET_CATEGORY_DETAIL_BY_TITLE: state => title => {
      return find(state.category_details, { title });
    },

    GET_DESIGNS_BY_CATEGORY: state => id => {
      return filter(state.designs, { _catId: id });
    },

    GET_DESIGN_BY_ID: state => id => {
      return find(state.designs, { designId: id });
    }
  },

  mutations: {
    SET_CATEGORIES(state, payload) {
      state.categories = payload.categories;
    },

    SET_DESIGN(state, payload) {
      const index = findIndex(state.designs, design => {
        return design.designId === payload.designId;
      });

      if (index !== -1) {
        state.designs[index] = payload;
      } else {
        state.designs.push(payload);
      }
    },

    SET_DESIGNS(state, payload) {
      state.designs[payload.designs.id] = payload.designs.items;
    },

    SET_TEMPLATES(state, payload) {
      state.templates = payload.templates;
    },

    SET_TEMPLATE_DETAILS(state, payload) {
      state.category_details = payload;
    }
  },

  actions: {
    async GET_CATEGORIES({ commit }) {
      const response = await TemplateCategories.getTemplateCategories();
      const { data } = response;
      if (data) {
        commit('SET_CATEGORIES', { categories: data });
      }
      return response;
    },

    GET_DESIGNS_BY_CATEGORY({ commit, state }, payload) {
      return client
        .get('/custom/templates/categories/' + payload.id + '/designs')
        .then(response => {
          // if (response.data && response.data.id && response.data.items) {
          // commit('SET_DESIGNS', { designs: response.data });
          // }

          return response;
        })
        .catch(err => {
          return err;
        });
    },

    GET_DESIGN_BY_ID({ commit, state }, payload) {
      const _catId = get(payload, '_catId', '');
      const previews = get(payload, 'previews', []);

      return client
        .get('/custom/templates/designs/' + payload.id)
        .then(response => {
          if (response) {
            // Set the category id and preview thumbnails because we don´t get these in the response
            response._catId = _catId;
            response.previews = previews;
            commit('SET_DESIGN', response);
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    },

    GET_TEMPLATES({ commit, state }) {
      TemplatesService.getTemplates()
        .then(response => {
          if (response.data) {
            commit('SET_TEMPLATES', { templates: response.data });
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    },

    GET_TEMPLATE_DETAILS({ commit }) {
      return TemplatesService.getTemplateCategoryDetails()
        .then(response => {
          if (response.data) {
            commit('SET_TEMPLATE_DETAILS', response.data);
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    }
  }
};
